import { render } from "./DashboardMatchSaleQuote.vue?vue&type=template&id=75b133bd&scoped=true"
import script from "./DashboardMatchSaleQuote.vue?vue&type=script&lang=js"
export * from "./DashboardMatchSaleQuote.vue?vue&type=script&lang=js"

import "./DashboardMatchSaleQuote.vue?vue&type=style&index=0&id=75b133bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b133bd"]])

export default __exports__